import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {ComplianceDocument} from '../../models/compliance-document';

@Injectable({
  providedIn: 'root'
})
export class AdvertiserComplianceDocumentService extends AbstractModelService<ComplianceDocument> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/advertiser/compliance-document', ComplianceDocument);
  }
}
